import actionTypes from '../actionsFactory/types';

const {
  SET_USER_ASSETS_PUBLIC_STATUS,
  HIDE_HEADER_LANG_SELECT,
} = actionTypes;

export const setPublicAssetsStatus = (status) => (dispatch) => dispatch({
  type: SET_USER_ASSETS_PUBLIC_STATUS, data: status,
});
export const hideHeaderLangSelect = (data) => (dispatch) => dispatch({
  type: HIDE_HEADER_LANG_SELECT, data,
});

export default {};
